export default __webpack_public_path__ + "static/media/pp.4bfa072b.jpg";